export default __webpack_public_path__ + "static/media/asl-project@2x.7b483eb4.jpg";